<template>
  <v-card class="my-2 px-4 py-3 v-card-customer" color="grey lighten-2" style="border-radius: 0.75rem" flat>
    <v-layout class="subtitle-1">
      Active Filters
      <v-spacer></v-spacer>
      <v-btn slot="activator" color="grey" dark small text @click="clearAll">
        <v-icon class="mr-2">fa-times-circle</v-icon> clear all filters
      </v-btn>
    </v-layout>
    <bool-filter-chips
      v-for="filter in activeBool"
      :key="filter.value"
      :filter="filter"
      :prefix="'bool.'"
    ></bool-filter-chips>
    <bool-filter-chips
      v-for="filter in activeFilter"
      :key="filter.value"
      :filter="filter"
      :prefix="''"
    ></bool-filter-chips>
    <enquiry-filter-chips
      v-for="enquiryStatusId in CustomerPageFilters.enquiryStatuses"
      :key="enquiryStatusId"
      :enquiryStatusId="enquiryStatusId"
    ></enquiry-filter-chips>
    <owner-filter-chips
      v-for="ownerId in CustomerPageFilters.owners"
      :key="ownerId"
      :ownerId="ownerId"
    ></owner-filter-chips>
    <answer-filter-chips v-for="answerId in answerIds" :key="answerId" :answerId="answerId"></answer-filter-chips>
    <nullable-filter-chip v-if="CustomerPageFilters.referrer" :filter="referrerFilter" />
    <nullable-filter-chip v-if="CustomerPageFilters.referrerType" :filter="referrerTypeFilter" />
    <nullable-filter-chip v-if="CustomerPageFilters.providerId" :filter="providerIdFilter" />
    <nullable-filter-chip v-if="CustomerPageFilters.productId" :filter="productIdFilter" />
    <nullable-filter-chip v-if="CustomerPageFilters.journeyId" :filter="journeyIdFilter" />
    <nullable-filter-chip v-if="CustomerPageFilters.providerReference" :filter="providerReferenceFilter" />
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import BoolFilterChips from './Active/BoolFilterChips';
import EnquiryFilterChips from './Active/EnquiryFilterChips';
import OwnerFilterChips from './Active/OwnerFilterChips';
import AnswerFilterChips from './Active/AnswerFilterChips';
import NullableFilterChip from '@/components/Platform/Customers/Filters/Active/NullableFilterChip';

export default {
  name: 'active-filters',
  components: { NullableFilterChip, AnswerFilterChips, OwnerFilterChips, EnquiryFilterChips, BoolFilterChips },
  data() {
    return {
      bool: [
        { icon: 'fad fa-fire', text: 'Hot prospect', value: 'hotProspect' },
        { icon: 'fad fa-university', text: 'Bank decline', value: 'bankDecline' },
        { icon: 'fad fa-user-chart', text: 'Broker referral', value: 'brokerReferral' },
        { icon: 'fad fa-phone-plus', text: 'To be called', value: 'toBeCalled' },
        { icon: 'fad fa-star', text: 'Trustpilot', value: 'trustpilot' },
        { icon: 'fad fa-star', text: 'TP invitation sent', value: 'trustpilot_invitation_sent' },
        { icon: 'fad fa-envelope-open', text: 'Financials sent', value: 'financialsSent' },
        { icon: 'fad fa-thumbs-up', text: 'Soft-search Consent', value: 'softSearchConsent' },
        { icon: 'fad fa-door-closed', text: 'Closed', value: 'closed' },
        { icon: 'fad fa-file-alt', text: 'Has documents', value: 'hasDocuments' },
        { icon: 'far fa-debug', text: 'Has enquiry errors', value: 'hasEnquiryErrors' },
        { icon: 'fad fa-person-sign', text: 'Has enquiry feedback', value: 'hasEnquiryFeedback' },
        { icon: 'fad fa-quote-right', text: 'Has enquiry quote', value: 'hasEnquiryQuote' },
      ],
      filters: [
        { icon: 'fad fa-envelope', text: 'No email', value: 'noEmail' },
        { icon: 'fad fa-envelope', text: 'With email', value: 'withEmail' },
        { icon: 'fad fa-door-open', text: 'No telephone', value: 'noPhone' },
        { icon: 'fad fa-door-open', text: 'With telephone', value: 'withPhone' },
        { icon: 'fad fa-people-carry', text: 'Referred (Elite)', value: 'eliteReferral' },
        { icon: 'fad fa-people-carry', text: 'Referred', value: 'referral' },
        { icon: 'fad fa-person-carry', text: 'Not referred', value: 'notReferral' },
        { icon: 'progress_full', text: 'Questions complete', value: 'questionsComplete' },
        { icon: 'progress_empty', text: 'Questions incomplete', value: 'questionsIncomplete' },
        { icon: 'speaker_notes_off', text: 'No enquiries', value: 'noEnquiries' },
        { icon: 'fab fa-product-hunt', text: 'Product', value: 'productId' },
        { icon: 'fab fa-mailchimp', text: 'Marketing opt-in', value: 'newsletterSignup' },
        { icon: 'fad fa-sync', text: 'Revolving deals', value: 'revolvingEnquiries' },
        { icon: 'fad fa-shipping-fast', text: 'Auto send', value: 'autoSendEnquiries' },
        { icon: 'fad fa-truck', text: 'Not auto send enquiries', value: 'notAutoSendEnquiries' },
      ],
      referrerFilter: { icon: 'fad fa-people-carry', text: 'Referrer', value: 'referrer' },
      referrerTypeFilter: { icon: 'fad fa-people-carry', text: 'Referrer Type', value: 'referrerType' },
      providerIdFilter: { icon: 'fad fa-coins', text: 'Provider', value: 'providerId' },
      productIdFilter: { icon: 'fab fa-product-hunt', text: 'Product', value: 'productId' },
      journeyIdFilter: { icon: 'fad fa-road', text: 'Journey', value: 'journeyId' },
      providerReferenceFilter: { icon: 'fad fa-tag', text: 'Provider Ref', value: 'providerReference' }
    };
  },
  computed: {
    ...mapGetters(['CustomerPageFilters']),
    activeBool: function() {
      return _.filter(this.bool, filter => this.CustomerPageFilters.bool[filter.value] === true);
    },
    activeFilter: function() {
      return _.filter(this.filters, filter => this.CustomerPageFilters[filter.value] === true);
    },
    answerIds: function() {
      return _.flatMap(this.CustomerPageFilters.answers);
    }
  },
  methods: {
    ...mapActions(['resetCustomerFilters', 'setCustomerPageFilters', 'getCustomerPage']),
    getPage: _.debounce(function() {
      this.getCustomerPage(false)
        .then(() => {})
        .catch(error => {
          console.log(error);
        });
    }, 250),
    clearAll() {
      this.resetCustomerFilters().then(() => {
        this.getPage();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
div.input-group {
  padding-top: 0;
}
::v-deep .input-group__details {
  display: none;
}
</style>
